/*import { useState, useEffect } from "react";
import client from "../api/client";

function IntentionChips({ value, onChange }) {
  const [chips, setChips] = useState([]);
  const selected = value || [];

  useEffect(() => {
    const fetchChips = async () => {
      try {
        const res = await client.get("/intention-tags");
        setChips(res.data);
      } catch (err) {
        console.error("Failed to fetch intention tags:", err);
      }
    };
    fetchChips();
  }, []);

  const toggleChip = (chipName) => {
    if (selected.includes(chipName)) {
      onChange(selected.filter(c => c !== chipName));
    } else {
      onChange([...selected, chipName]);
    }
  };

  return (
    <div className="IntentionChips">
      <p style={{ fontSize: "13px", opacity: 0.6, marginBottom: "10px" }}>
        Select any intentions for this session.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {chips.map(chip => (
          <span
            key={chip.id}
            onClick={() => toggleChip(chip.name)}
            style={{
              cursor: "pointer",
              padding: "5px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              border: selected.includes(chip.name)
                ? "1px solid rgba(255, 170, 51, 0.8)"
                : "1px solid rgba(255,255,255,0.2)",
              background: selected.includes(chip.name)
                ? "rgba(255, 170, 51, 0.15)"
                : "rgba(255,255,255,0.05)",
              color: selected.includes(chip.name) ? "#ffaa33" : "inherit",
              transition: "all 0.2s"
            }}
          >
            {chip.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default IntentionChips;
*/

import { useState, useEffect } from "react";
import client from "../api/client";

const CANNABIS_ONLY = ["Sleep", "Social ease", "Energy", "Nausea relief", "Appetite", "Movement/exercise", "Clarity/focus"];
const MUSHROOM_ONLY = ["Integration", "Trauma Processing", "Ego Dissolution", "Shadow Work", "Relationship Healing", "Ceremony"];

function IntentionChips({ value, onChange, medicineType }) {
  const [chips, setChips] = useState([]);
  const selected = value || [];

  useEffect(() => {
    const fetchChips = async () => {
      try {
        const res = await client.get("/intention-tags");
        setChips(res.data);
      } catch (err) {
        console.error("Failed to fetch intention tags:", err);
      }
    };
    fetchChips();
  }, []);

  const filteredChips = chips.filter(chip => {
    if (medicineType === "mushroom") return !CANNABIS_ONLY.includes(chip.name);
    if (medicineType === "cannabis") return !MUSHROOM_ONLY.includes(chip.name);
    return true;
  });

  const toggleChip = (chipName) => {
    if (selected.includes(chipName)) {
      onChange(selected.filter(c => c !== chipName));
    } else {
      onChange([...selected, chipName]);
    }
  };

  return (
    <div className="IntentionChips">
      <p style={{ fontSize: "13px", opacity: 0.85, marginBottom: "10px" }}>
        Select any intentions for this session:
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {filteredChips.map(chip => (
          <span
            key={chip.id}
            onClick={() => toggleChip(chip.name)}
            style={{
              cursor: "pointer",
              padding: "5px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              border: selected.includes(chip.name)
                ? "1px solid rgba(255, 170, 51, 0.8)"
                : "1px solid rgba(255,255,255,0.2)",
              background: selected.includes(chip.name)
                ? "rgba(255, 170, 51, 0.15)"
                : "rgba(255,255,255,0.05)",
              color: selected.includes(chip.name) ? "#ffaa33" : "inherit",
              transition: "all 0.2s"
            }}
          >
            {chip.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default IntentionChips;